const updateHistory = queryString => {
  window.history.pushState('', '', `${window.location.href.replace(window.location.search, '')}?${queryString}`);
};

export default updateHistory;
